import React from "react";
import stylesLess from "./xt.module.less";

import Nav from "@xt/Nav";
import Foot from "@xt/Foot";
import { Platform } from "@xt/xtbase";
import { useRouter } from "next/router";

export default function Layout({ children, isShowNav=true, isShowFoot=true, style={} }) {
  const router = useRouter();

  const showNav = !Platform.isInApp() && (isShowNav != false);
  const showFoot = !Platform.isInApp() && (isShowFoot != false);
  const styles = {...style};

  const renderNav = ()=>{
    // 统一使用 fixed 模式，只有在显示 nav 时才显示底部 bar
    return <Nav mode="fixed" bgColor="#181a20" bottomBar={showNav} />
  }

  return (
    <div
      className={`${stylesLess.page}`}
      style={styles}
    >
      <div>
        {showNav ? renderNav() : null}
        <div className={`${stylesLess.main} ${showNav ? stylesLess.mainFixedNav : ''} ${!showNav ? stylesLess.mainNoNav : ''}`}>{children}</div>
        {/* {showFoot ? <Foot/> : null} */}
      </div>
    </div>
  );
}